<template>
  <div class="container-us">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title">公司档案</span>
      </div>
      <div class="text item">
        <div class="left">公司名称</div>
        <div class="right">
          元芝庄药业有限公司（Yuanzhizhuang Pharmaceutical Comércio Limitada）
        </div>
      </div>
      <div class="text item">
        <div class="left">营业执照</div>
        <div class="right">
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="url2"
              :preview-src-list="srcList2"
            >
            </el-image>
          </div>
        </div>
      </div>
      <div class="text item">
        <div class="left">食品经营许可证</div>
        <div class="right">
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="url1"
              :preview-src-list="srcList1"
            >
            </el-image>
          </div>
        </div>
      </div>
      <div class="text item">
        <div class="left">药品经营许可证</div>
        <div class="right">
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="url3"
              :preview-src-list="srcList3"
            >
            </el-image>
          </div>
        </div>
      </div>
      <div class="text item">
        <div class="left">医药器械备案</div>
        <div class="right">
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="url4"
              :preview-src-list="srcList4"
            >
            </el-image>
          </div>
        </div>
      </div>
      <div class="text item">
        <div class="left">微信号</div>
        <div class="right">
          drugcore
        </div>
      </div>
      <div class="text item">
        <div class="left">微信二维码</div>
        <div class="right">
          <img
            class="code"
            src="../../../assets/moblie/images/serve.png"
            alt=""
          />
        </div>
      </div>
      <div class="text item">
        <div class="left">QQ</div>
        <div class="right">
          695396498
        </div>
      </div>
      <div class="text item">
        <div class="left">电话</div>
        <div class="right">
          厦门：18046284242
        </div>
      </div>
      <div class="text item">
        <div class="left">邮箱账号</div>
        <div class="right">
          service@droga.cn
        </div>
      </div>
      <div class="text item">
        <div class="left">公司简介</div>
        <div class="right">
          元芝庄药业有限公司（Yuanzhizhuang Pharmaceutical Comércio
          Limitada）是经澳门政府卫生局注册成立的专业药品批发商，致力于国际药品流通批发，国际知名医药品牌代理及销售。自公司创立以来，五洲药物从最初单一的贸易结构逐步转变为现在多元化、规模化、科学化、系统化的新型贸易服务产业。现如今，五洲药物以参比制剂，临床试验药品的进口为主营业务，以品牌与仿制药品、市场短缺药品、紧急医疗需求采购为辅。不断为上下游客户提供品牌、市场、网络、信息等多层面的增值服务，是国内外上百家医药企业不可或缺的重要贸易桥梁。
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CompanyData",
  data() {
    return {
      url2: require("../../../assets/moblie/images/certificate/2.png"),
      srcList2: [require("../../../assets/moblie/images/certificate/2.png")],
      url1: require("../../../assets/moblie/images/certificate/1.png"),
      srcList1: [require("../../../assets/moblie/images/certificate/1.png")],
      url3: require("../../../assets/moblie/images/certificate/3.jpg"),
      srcList3: [require("../../../assets/moblie/images/certificate/3.jpg")],
      url4: require("../../../assets/moblie/images/certificate/4.png"),
      srcList4: [require("../../../assets/moblie/images/certificate/4.png")]
    };
  }
};
</script>

<style scoped>
.container-us {
  height: 100%;
  background: #fff;
}
.box-card {
  width: 100% !important;
}
.title {
  font-size: 16px;
  font-weight: 700;
  color: 666;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #eee;
  padding-bottom: 18px;
}
.item .left {
  width: 30%;
  font-weight: 550;
  color: 666;
}
.item .right {
  width: 60%;
}
.item .right img {
  width: 100%;
}
.item .right .code {
  width: 60%;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
}
</style>
